import { useHotkeys } from '../../hooks/useHotkeys';
import { CustomPopover } from '../CustomPopover';
import { EmbedCreateMenu } from '../EmbedCreateMenu';
import { commandMenuState } from './store';
import type { MenuProps } from './types';

export const CreateEmbedMenu = ({ onClose, suggestion }: MenuProps) => {
  const { editor, clientRect, range } = suggestion;
  const { menuOptions } = commandMenuState();

  useHotkeys(
    editor,
    {
      Escape: () => {
        onClose();
      },
    },
    [onClose],
  );

  if (menuOptions?.type !== 'embed') return null;

  const handleCreateEmbed = (href: string) => {
    try {
      editor.commands.createEmbed({ range, href, type: menuOptions.embedType });
    } catch (e) {
      console.error(e);
    }
    onClose();
  };

  return (
    <CustomPopover
      editor={editor}
      clientRect={clientRect}
      paperProps={{
        sx: {
          maxHeight: '330px',
          width: '280px',
          overflowY: 'auto',
        },
      }}
    >
      <EmbedCreateMenu
        createEmbed={handleCreateEmbed}
        onClose={onClose}
        options={menuOptions}
      />
    </CustomPopover>
  );
};
